import {useQuery} from "@tanstack/react-query";
import axios from "axios";

export const useGetGlobalInventoryReport = (userToken: string = "") => {
	console.log(process.env.REACT_APP_API_URL);
	const url = process.env.REACT_APP_API_URL || 'https://api.concept.lawscore.com';

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(
			`${url}/api/global-inventory-report`,
			{
				headers: { 'Authorization': `bearer ${userToken}` }
			}
		);
		const data: any = response.data;

		return data.data;
	};

	return useQuery<any[]>({
		queryKey: [
			"Global-Inventory-Report"
		],
		queryFn: queryFn,
		enabled: userToken !== "",
		refetchOnWindowFocus: false
	});
};
